//import 'core-js/stable';
//import 'picturefill';
import React from 'react';
import ReactDOM from 'react-dom';

import svg4everybody from 'svg4everybody';
import 'modules/header';
import StandAloneAdvisoryContent from './components/widgets/standAloneAdvisoryContent';
import StandAloneWeekOpenDays from './components/widgets/weekopendays/standAloneWeekOpenDays';
import CallCenterHeader from './components/widgets/CallCenterHeader';
import SessionCheck from './components/widgets/SessionCheck';

import TopAirDestinations from './components/trends/topAirDestinations';
import TopDestinations from './components/trends/topDestinations';
import TopHotelsTgPackages from './components/trends/topHotelsTgPackages';
import TopCruises from './components/trends/topCruises';
import TopSunquests from './components/trends/topSunquests';

svg4everybody();
let app = document.getElementById('app');
let page = '';

let standAloneApp = document.getElementById('appStandaloneHeader');
let appStandaloneCallCenterSection = document.getElementById('appStandaloneCallCenterSection');

let trendsection05 = document.getElementById('trendsection05');
let trendsection01 = document.getElementById('trendsection01');
let trendsection02 = document.getElementById('trendsection02');
let trendsection03 = document.getElementById('trendsection03');
let trendsection04 = document.getElementById('trendsection04');

// if(app != '' && app != null && app != undefined) {
//     page = app.dataset.page;  
// } 

if (standAloneApp != '' && standAloneApp != null) {
    app = document.getElementById('appStandaloneHeader');
    page = app.dataset.page;
} else if (appStandaloneCallCenterSection !== '' && appStandaloneCallCenterSection != null) { 
    app = document.getElementById('appStandaloneCallCenterSection');
    page = app.dataset.page;
} else {
    app = document.getElementById('app');
    page = app.dataset.page;
    
}

if (page == 'standAloneHeader') {
    const advisoryContentElement = document.getElementById('advisoryContent');
    const weekOpenDaysElement = document.getElementById('weekOpenCloseDays');

    ReactDOM.render(<StandAloneAdvisoryContent language={app.dataset?.language}/>, advisoryContentElement);
    ReactDOM.render(<StandAloneWeekOpenDays />, weekOpenDaysElement);

    const sessionElement = document.getElementById('sessionPopUp');
    
/* commented for session pop up */

if (sessionElement !== null) {
   const sessionData = document.getElementById('lastaccess').getAttribute('value');
   ReactDOM.render(<SessionCheck lastaccess={sessionData} />, sessionElement);
}
/* commented code */
    //import('weekopendays');
    //import('advisoryContent');

} else if (page == 'appStandaloneCallCenterSection') {
    const agentData = document.getElementById('AccountData').getAttribute('value');
  
    const advisoryContentElement = document.getElementById('callcenterComponent');
  //  const weekOpenDaysElement = document.getElementById('weekOpenCloseDays');

    ReactDOM.render(<CallCenterHeader agentData={agentData} />, advisoryContentElement);
  //  ReactDOM.render(<StandAloneWeekOpenDays />, weekOpenDaysElement);

  const sessionElement = document.getElementById('sessionPopUp');
    
  /* commented for session pop up */
  
  if (sessionElement !== null) {
     const sessionData = document.getElementById('lastaccess').getAttribute('value');
     ReactDOM.render(<SessionCheck lastaccess={sessionData} />, sessionElement);
  }

} else {
    import('signin')
    import('header')
    import('signup')
    import('engine');
    import('forgot-password');
    import('reset-password');
    import('weekopendays');
    import('pages/webinar');
    import('advisoryContent');
    import('lujureInquireForm');
    import('canadaYoutubeVideo');
    import('canadaEbrochures');
    import('healthArrivalYoutubeVideo');
    import('pages/myBookingContent');

    if (page === 'home' || page === 'redtagHome' || page === 'tdcHome' || page === 'AMAHome') {
        import('pages/home');
        import('pages/latestNewsBlog');
        import('pages/topToursTable');
    } else if (page == 'cheap-flights') {
        import('pages/home');
        import('pages/travelNewsUpdates')
    } else if (page == 'hotel-deals') {
        import('pages/home');
        import('pages/hotels');
    } else if (page == 'verify') {
        import('pages/verify');
    } else if (page == 'car-rental-deals' || page == 'cars-promotion') {
        import('pages/home');
        import('pages/hotels');
        import('pages/car');
    } else if (page == 'cruise-deals' || page == 'sunquest' || page == 'disney' || page == 'add-ons' || page == 'travelgenie' || page == 'flights-promotion' || page == 'canada') {
        import('pages/home');
    } else if (page == 'profile') {
        import('account-setting');
    } else if (page == 'autoeurope') {
        import('pages/home');
        import('pages/autoeurope');
    } else if (page == 'e-flyers') {
        import('pages/home');
        import('pages/eFlyer');
    } else if (page == 'e-docs') {
        import('pages/home');
        import('pages/eDocs');
    } else if (page == 'merit-golf-ski') {
        import('pages/home');
        import('pages/eDocsMeritGolfAndSki');
    } else {
        // import('pages/dynamic');
        // import('pages/flights');
        import('pages/home');
        import('pages/travelNewsUpdates');
        import('pages/latestNewsBlog');
        import('pages/topToursTable');
    }
}
if (page === 'home' || page === 'redtagHome' || page === 'tdcHome' || page === 'AMAHome') {
    if (trendsection05 != '' && trendsection05 != null) {
        ReactDOM.render(<TopAirDestinations env={trendsection05.dataset.env} start={trendsection05.dataset.start} end={trendsection05.dataset.end} />, trendsection05);
    }

    if (trendsection01 != '' && trendsection01 != null) {
        ReactDOM.render(<TopDestinations env={trendsection01.dataset.env} start={trendsection01.dataset.start} end={trendsection01.dataset.end} />, trendsection01);
    }

    if (trendsection02 != '' && trendsection02 != null) {
        ReactDOM.render(<TopHotelsTgPackages env={trendsection02.dataset.env} start={trendsection02.dataset.start} end={trendsection02.dataset.end} />, trendsection02);
    }

    if (trendsection03 != '' && trendsection03 != null) {
        ReactDOM.render(<TopCruises env={trendsection03.dataset.env} start={trendsection03.dataset.start} end={trendsection03.dataset.end} />, trendsection03);
    }

    if (trendsection04 != '' && trendsection04 != null) {
        ReactDOM.render(<TopSunquests env={trendsection04.dataset.env} start={trendsection04.dataset.start} end={trendsection04.dataset.end} />, trendsection04);
    }
}
